import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";

const Sidebar = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { pathname } = useLocation();
  const history = useHistory();

  // Toggle submenu (only for parent menu)
  const handleParentMenuClick = (index) => {
    if (openIndex === index) {
      // If already open, do nothing (optional: or collapse if you want)
      return;
    }
    setOpenIndex(index);
  };

  // Direct link click (non-submenu)
  const handleDirectClick = (index) => {
    setOpenIndex(index);
  };

  useEffect(() => {
    if (pathname === "/") {
      setOpenIndex(1);
    } else if (pathname === "/Location-master") {
      setOpenIndex(2);
    } else if (pathname === "/Attendance-Download") {
      setOpenIndex(4);
    } else if (
      [
        "/Leave-application",
        "/Reimbursement",
        "/Over_time",
        "/On_duty",
        "/Attendance",
        "/message",
      ].includes(pathname)
    ) {
      setOpenIndex(3);
    } else {
      setOpenIndex(null);
    }
  }, [pathname]);

  const handleLogout = () => {
    localStorage.clear();
    history.replace("/login");
  };

const handlemenu = () => {
  const body = document.body;
  if (body.classList.contains("mini-sidebar")) {
    body.classList.remove("mini-sidebar");
  }
};

  return (
    <div className="sidebar" id="sidebar">
      <Scrollbars>
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu mt-3">
            <ul className="sidebar-vertical">

              {/* Employee Master */}
              <li>
                <Link
                  to="/"
                  onClick={() => handleDirectClick(1)}
                  className={openIndex === 1 ? "subdrop active" : ""}
                >
                  <i className="fe fe-user" />
                  <span>Employee Master</span>
                </Link>
              </li>

              {/* Location Master */}
              <li>
                <Link
                  to="/Location-master"
                  onClick={() => handleDirectClick(2)}
                  className={openIndex === 2 ? "subdrop active" : ""}
                >
                  <i className="fe fe-map-pin" />
                  <span>Location Master</span>
                </Link>
              </li>

              <li>
                <Link
                  to="/Attendance-Download"
                  onClick={() => handleDirectClick(4)}
                  className={openIndex === 4 ? "subdrop active" : ""}
                >
                  {/* <i className="fe fe-clock" /> */}
                 <i className="fa-solid fa-clipboard-user"></i>
                  <span>Attendance Master</span>
                </Link>
              </li>

              {/* Reports Menu */}
              <li className="submenu">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleParentMenuClick(3);
                    handlemenu()
                  }}
                  className={openIndex === 3 ? "subdrop active" : ""}
                >
                  <i className="fe fe-file-text" />
                  <span>Reports</span>
                  <span className="menu-arrow" />
                </Link>
                <ul
                  style={{
                    display: openIndex === 3 ? "block" : "none",
                  }}
                >
                  <li>
                    <Link
                      to="/Leave-application"
                      className={pathname === "/Leave-application" ? "active" : ""}
                    >
                      Leave Application
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Reimbursement"
                      className={pathname === "/Reimbursement" ? "active" : ""}
                    >
                      Reimbursement
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/Over_time"
                      className={pathname === "/Over_time" ? "active" : ""}
                    >
                      Over Time
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link
                      to="/On_duty"
                      className={pathname === "/On_duty" ? "active" : ""}
                    >
                      On Duty
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/Attendance"
                      className={pathname === "/Attendance" ? "active" : ""}
                    >
                      Attendance
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/Attendance-Download"
                      className={pathname === "/Attendance-Download" ? "active" : ""}
                    >
                      Attendance Download
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/message"
                      className={pathname === "/message" ? "active" : ""}
                    >
                      Message
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Logout */}
              <li>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                  className="subdrop"
                  to=""
                >
                  <i className="fe fe-log-out" />
                  <span>Logout</span>
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};

export default Sidebar;